module.exports = __webpack_public_path__ + "img/trinity_construction.26798bb0.gif";